import type { Column } from '@tanstack/react-table'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface DataTableColumnHeaderProps<TData, TValue> {
  column: Column<TData, TValue>
  title: string
  className?: string
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>
  }

  const sorted = column.getIsSorted()
  const nextDirection = sorted === 'asc' ? 'descending' : sorted === 'desc' ? 'unsorted' : 'ascending'

  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        'group -ml-3 h-8 cursor-pointer',
        sorted && 'bg-accent/60 font-semibold',
        className
      )}
      onClick={() => column.toggleSorting(sorted === 'asc')}
      title={`Sort by ${title} (click for ${nextDirection})`}
    >
      <span>{title}</span>
      {sorted === 'desc' ? (
        <ArrowDown className="ml-1 h-3 w-3" />
      ) : sorted === 'asc' ? (
        <ArrowUp className="ml-1 h-3 w-3" />
      ) : (
        <ArrowUpDown className="ml-1 h-3 w-3 text-muted-foreground/50 group-hover:text-foreground" />
      )}
    </Button>
  )
}
